import React from "react";
import { Modal, Button } from "reactstrap";
import { handlePostRequest } from "../../helpers/handle-response";
import { formatCurrency } from "../../helpers/functions";

const DeleteModal = ({ open, setOpen, rowToDelete, delFunc }) => {
  return (
    <Modal
      className="modal-dialog-centered"
      size={"lg"}
      isOpen={open.Delete}
      toggle={() => setOpen({ ...open, Delete: !open.Delete })}
    >
      <div className="modal-header">
        <h3 className="modal-title" id="exampleModalLabel">
          Obriši gradilište
        </h3>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => setOpen({ ...open, Delete: !open.Delete })}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="mx-auto">
        <h2 className="ml-4 ml-sm-0">Jeste li sigurni da želite obrisati gradilište?</h2>
        <ul>
          <li>
            Naziv:{" "}
            <span className="font-weight-bold"> {rowToDelete.Naziv}</span>
          </li>
          <li>
            Izvodac:{" "}
            <span className="font-weight-bold"> {rowToDelete.Izvodac}</span>
          </li>
          <li>
            Cijena bez PDV-a:{" "}
            <span className="font-weight-bold">
              {" "}
              {formatCurrency(rowToDelete.CijenaBezPdv)} HRK
            </span>
          </li>
          <li>
            Investitor:{" "}
            <span className="font-weight-bold"> {rowToDelete.Investitor}</span>
          </li>
          <li>
            Gradevina:{" "}
            <span className="font-weight-bold"> {rowToDelete.Gradevina}</span>
          </li>
          <li>
            Lokacija:{" "}
            <span className="font-weight-bold"> {rowToDelete.Lokacija}</span>
          </li>
        </ul>
        <Button
          className="mx-auto my-2 d-flex"
          color="danger"
          onClick={delFunc}
        >
          Obriši
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteModal;
